import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchGet, getFormattedDateForURL, getrecheduledate, getImgPath } from '../../common/common';
import { updateHeaderText, updateCheckoutDet, updateUserGender } from '../../actions/editPolicy-actions';
import { Rs } from '../common/constants';
import store from '../../store';
import LineInp from '../common/input';
import Radio from '../common/radio';
import Check from '../common/checkbox';
import Modify from '../modify/modify';
import './checkout.css';
import moment from 'moment';
let mode = '';
let fromCity = '';
let toCity = '';
let fromCityId = '';
let toCityId = '';
let journeyDate = '';
let returnDate = '';
let rescheduleCharge = '';

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            mobile: '',
            email: '',
            payopt: '',
            insuranceVal: 0,
            insurance: 'on',
            onwardFare: 0,
            onwardGst: 0,
            onwardPickDrop: 0,
            onwardScharge: 0,
            discountAmt: 0,
            paymentOption: false,
            showPassDetailsOnward: 0,
            passContactInfo: false,
            showPoint: '',
            isMobile: 0,
            activeTnC: false,
            customerGSTN: '',
            companyGSTNo: '',
            regCompanyName: '',
            buttonLabel: 'APPLY',
            countryCode: '+91',
            rescheduleCharge: 0,
            errormsg: '',
            oldBookingData: {},
            amountToPay: 0,
            previousamount: 0
        }
    }

    componentDidMount() {
        window.addEventListener('click', (e) => {

            if ((e.target && e.target.className === 'couponMobile-back-icon') || (e.target.parentNode && e.target.parentNode.className === 'couponMobile-back-icon') || (e.target.parentNode.parentNode && e.target.parentNode.parentNode.className === 'couponMobile-back-icon')) {
                store.dispatch(updateHeaderText('text', 'checkout-back-icon', 'text1', 'Payee Contact Details', 'text2', ''))
                this.setState({ isMobile: 0 });
            }

            if ((e.target && e.target.className === 'otp-back-icon') || (e.target.parentNode && e.target.parentNode.className === 'otp-back-icon') || (e.target.parentNode.parentNode && e.target.parentNode.parentNode.className === 'otp-back-icon')) {
                store.dispatch(updateHeaderText('text', 'couponMobile-back-icon', 'text1', 'Redeem Coupons', 'text2', ''))
                this.setState({ isMobile: 2, redeemCoupon: false });
            }

        })

        store.dispatch(updateHeaderText('text', 'psdetails-back-icon', 'text1', 'Passenger details', 'text2', ''));
        const fetchurl = '/api/resource/BookingInfo?PNR=' + window.location.href.split('/')[6].split('?')[0];
        fetchGet(fetchurl).then((datas) => {
            if (datas.Status) {
                let olddata = datas.BookingInfo.APIGetBookingDetailsResult[0];
                this.setState({ oldBookingData: olddata });
                if (this.props.editPolicy.order.length === 0) {
                    const url = '/api/expco/getOrderDetails?token=' + this.props.match.params.token;
                    const that = this;
                    fetchGet(url).then((data) => {
                        let onwardFare = that.state.onwardFare;
                        let onwardGst = that.state.onwardGst;
                        let onwardPickDrop = that.state.onwardPickDrop;
                        let onwardScharge = that.state.onwardScharge;
                        let discountAmt = that.state.discountAmt;
                        let showInsurance = that.state.showInsurance;
                        mode = 'oneway';
                        fromCity = data.onward.fromCity;
                        toCity = data.onward.toCity;
                        journeyDate = data.onward.journeyDate;
                        fromCityId = data.onward.fromCityId;
                        toCityId = data.onward.toCityId;

                        const oldPaxDetails = olddata.PaxDetail;

                        Object.keys(data.onward.seatDetails).forEach((el, index) => {

                            data.onward.seatDetails[el]['isMale'] = data.onward.seatDetails[el].gender && data.onward.seatDetails[el].gender.toLowerCase() === 'm';
                            data.onward.seatDetails[el]['isFemale'] = data.onward.seatDetails[el].gender && data.onward.seatDetails[el].gender.toLowerCase() === 'f';

                            if ((oldPaxDetails[index].PaxName == data.onward.seatDetails[el].name) && (oldPaxDetails[index].Age == data.onward.seatDetails[el].age)) {
                                data.onward.seatDetails[el].gender = oldPaxDetails[index].Gender == 'M' ? 'Male' : 'Female';
                                data.onward.seatDetails[el]['isMale'] = oldPaxDetails[index].Gender == 'M' ? true : '';
                                data.onward.seatDetails[el]['isFemale'] = oldPaxDetails[index].Gender == 'F' ? true : '';
                            }

                            onwardFare += data.onward.seatDetails[el].fare;
                            onwardGst += data.onward.seatDetails[el].serviceTax ? data.onward.seatDetails[el].serviceTax : 0;
                        });

                        if (data.onward.pickupcharge != null) {
                            onwardPickDrop = parseInt(data.onward.pickupcharge, 10);
                        }

                        if (data.onward.serviceCharge != null) {
                            onwardScharge = parseInt(data.onward.serviceCharge, 10);
                        }

                        const count = data.onward.seats.length;
                        const insuranceVal = data.showInsurance ? count * 20 : 0;
                        showInsurance = data.showInsurance;
                        discountAmt = parseInt(data.onward.discountAmount, 10);
                        let mobile = data.mobile;
                        let email = data.email;
                        that.setState({ insuranceVal, onwardFare, onwardGst, onwardPickDrop, onwardScharge, discountAmt, showInsurance, mobile, email });
                        store.dispatch(updateCheckoutDet(data));
                        this.getRescheduleCharges(olddata, data);
                    }).catch(function (error) {
                        console.log(error);
                    });
                } else {
                    const ord = this.props.editPolicy.order;
                    let onwardFare = this.state.onwardFare;
                    let onwardGst = this.state.onwardGst;
                    let onwardPickDrop = this.state.onwardPickDrop;
                    let onwardScharge = this.state.onwardScharge;
                    let showInsurance = this.state.showInsurance;
                    mode = 'oneway';
                    fromCity = ord.onward.fromCity;
                    toCity = ord.onward.toCity;
                    fromCityId = ord.onward.fromCityId;
                    toCityId = ord.onward.toCityId;
                    journeyDate = ord.onward.journeyDate;

                    const oldPaxDetails = olddata.PaxDetail;

                    Object.keys(ord.onward.seatDetails).forEach((el, index) => {
                        ord.onward.seatDetails[el]['isMale'] = ord.onward.seatDetails[el].gender && ord.onward.seatDetails[el].gender.toLowerCase() === 'm';
                        ord.onward.seatDetails[el]['isFemale'] = ord.onward.seatDetails[el].gender && ord.onward.seatDetails[el].gender.toLowerCase() === 'f';

                        if ((oldPaxDetails[index].PaxName == ord.onward.seatDetails[el].name) && (oldPaxDetails[index].Age == ord.onward.seatDetails[el].age)) {
                            ord.onward.seatDetails[el].gender = oldPaxDetails[index].Gender == 'M' ? 'Male' : 'Female';
                            ord.onward.seatDetails[el]['isMale'] = oldPaxDetails[index].Gender == 'M' ? true : '';
                            ord.onward.seatDetails[el]['isFemale'] = oldPaxDetails[index].Gender == 'F' ? true : '';
                        }

                        onwardFare += ord.onward.seatDetails[el].fare;
                        onwardGst += ord.onward.seatDetails[el].serviceTax ? ord.onward.seatDetails[el].serviceTax : 0;
                    });

                    if (ord.onward.pickupcharge != null) {
                        onwardPickDrop = parseInt(ord.onward.pickupcharge, 10);
                    }

                    if (ord.onward.serviceCharge != null) {
                        onwardScharge = parseInt(ord.onward.serviceCharge, 10);
                    }
                    const count = ord.onward.seats.length;
                    const insuranceVal = ord.showInsurance ? count * 20 : 0;
                    showInsurance = ord.showInsurance;

                    let discountAmt;
                    discountAmt = ord.onward.discountAmount;
                    let mobile = ord.mobile;
                    let email = ord.email;
                    let oldBookingData = olddata;
                    this.setState({ insuranceVal, onwardFare, onwardGst, onwardPickDrop, onwardScharge, discountAmt, showInsurance, mobile, email, oldBookingData });
                    this.getRescheduleCharges(oldBookingData, ord);
                }
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    getRescheduleCharges = (olddata, data) => {
        let prepaidCouponDiscount = 0;
        let couponDiscount = olddata.CouponDiscount;
        if (olddata.CouponBooking) {
            olddata.CouponBooking.map((el, index) => {
                if (el) {
                    if (el.CouponType == "Prepaid Card") {
                        prepaidCouponDiscount += el.CouponDiscount;
                        couponDiscount -= prepaidCouponDiscount;
                    }
                }
            })
        }
        const previousamount = Math.round(olddata.TotalFare + olddata.ServiceCharge + olddata.Tax - olddata.Disount - couponDiscount);
        let olddate = moment(new Date(olddata.JourneyDate)).format();
        let newdate = moment(new Date(getrecheduledate(data.onward.journeyDate))).format();
        let amountToPay = 0;
        let rescheduleCharge = this.state.rescheduleCharge;
        const SeatNos = data.onward.seats.join();
        const apiurl = '/api/resource/APIModificationPolicyWithCharge?PNR=' + window.location.href.split('/')[6].split('?')[0] + '&RouteCode=' + data.onward.routeCode + '&SeatNos=' + SeatNos;;
        fetchGet(apiurl).then((dt) => {

            let policy = JSON.parse(JSON.stringify(dt)).APIModificationPolicyWithChargeResult;

            if (policy.ModificationCharges > 0) {
                rescheduleCharge = policy.ModificationCharges;
            } else if (policy.ModificationPer > 0) {
                rescheduleCharge = Math.ceil((previousamount * policy.ModificationPer) / 100);
            } else {
                rescheduleCharge = 0;
            }

            amountToPay = parseInt(this.state.onwardFare, 10) + parseInt(this.state.onwardPickDrop, 10) + parseInt(this.state.onwardScharge, 10) + parseInt(rescheduleCharge, 10) - (parseInt(this.state.discountAmt, 10) + parseInt(previousamount, 10));
            this.setState({ rescheduleCharge, previousamount, amountToPay });
        }).catch(function (error) {
            console.log(error);
        });
    }

    singlePassenger = () => {
        return (
            <div style={{
                padding: '15px 0px',
                backgroundColor: window.color['buttonColor'],
                textAlign: 'center',
                color: '#FFF',
                borderRadius: '10px',
                fontSize: '20px',
                fontWeight: '600',
            }} onClick={() => {
                this.setState({ passContactInfo: true })
                store.dispatch(updateHeaderText('text', 'checkout-back-icon', 'text1', 'Payee Contact Details', 'text2', ''))
            }} >
                CONFIRM & PROCEED TO CHECKOUT
            </div>
        )
    }

    multiPassengerOnward = () => {
        return (
            <div style={{
                padding: '15px 0px',
                backgroundColor: window.color['buttonColor'],
                textAlign: 'center',
                color: '#FFF',
                borderRadius: '10px',
                fontSize: '20px',
                fontWeight: '600',
            }} onClick={() => this.setState({ showPassDetailsOnward: this.state.showPassDetailsOnward + 1 })}>
                NEXT PASSENGER DETAILS
            </div>
        )
    }

    enterPassDetailsOnwards = () => {
        const ord = this.props.editPolicy.order;
        const loop = ord.length !== 0 ? ord.onward.seats : false;
        if (loop) {
            const seats = ord.onward.seatDetails;
            return (
                <div className='card font14' style={{
                    width: '100%',
                    height: 'calc(100% - 60px)',
                    position: 'absolute',
                    bottom: '0px',
                    left: '0px',
                    padding: '15px',
                    backgroundColor: '#EEEEEE',
                    overflowY: 'scroll'
                }} >
                    {/* <div>You have selected {loop.length > 1 ? 'Seats: ' : 'Seat: '} {loop.join(', ')}</div> */}
                    {/* <div style={{ color: 'red' }}>{this.state.errormsg}</div> */}
                    {loop.map((el, index) => {
                        if (this.state.showPassDetailsOnward === index) {
                            return (
                                <div key={index}>
                                    <div className='pass-info' style={{ backgroundColor: '#ffffff', padding: '25px 15px', marginTop: '0px', marginBottom: '25px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,.2)' }}>
                                        <div className='pass-card--info'>
                                            <div>Passenger #{index + 1}</div>
                                            <div>Seat No. {seats[el].seatNo}</div>
                                        </div>
                                        <div className='pass-card--user'>
                                            <LineInp
                                                type='text'
                                                placeholder='Enter Name'
                                                name={'paxName[' + index + ']'}
                                                value={seats[el].name || ''}
                                                style={{ width: '48%', display: 'flex' }}
                                                tab={(index * 4) + 1}
                                                isReadyOnly={true}
                                                className='txtLineInp txtdisabled'
                                            />
                                            <LineInp
                                                type='tel'
                                                placeholder='Enter Age'
                                                name={'paxAge[' + index + ']'}
                                                value={seats[el].age || ''}
                                                style={{ width: '48%', display: 'flex', padding: '15px 0px 30px' }}
                                                tab={(index * 4) + 2}
                                                max={2}
                                                isReadyOnly={true}
                                                className='txtLineInp txtdisabled'
                                            />
                                        </div>
                                        <div>
                                            <div style={{ color: window.color['searchBoxBgColor'] }}>SELECT GENDER</div>
                                            <div className='pass-card--gender'>
                                                <Radio
                                                    value='Male'
                                                    showValue='Male'
                                                    name={'paxGender[' + index + ']'}
                                                    index={index}
                                                    checked={seats[el].gender === 'Male'}
                                                    handleChange={(event) => this.handleClick(event.target.value, el)}
                                                    disabled={seats[el].isFemale}
                                                    className='gender-radio'
                                                    lblClass='gender-label-male'
                                                    spanOuterClass='span-outer'
                                                    spanInnerClass='span-inner'
                                                />
                                                <Radio
                                                    value='Female'
                                                    showValue='Female'
                                                    name={'paxGender[' + index + ']'}
                                                    index={index}
                                                    checked={seats[el].gender === 'Female'}
                                                    handleChange={(event) => this.handleClick(event.target.value, el)}
                                                    disabled={seats[el].isMale}
                                                    className='gender-radio'
                                                    lblClass='gender-label-female'
                                                    spanOuterClass='span-outer'
                                                    spanInnerClass='span-inner'
                                                />
                                            </div>
                                        </div>
                                        <div className='pass-card--btn'>
                                            {seats[el].name && seats[el].age && seats[el].gender ?
                                                loop.length === index + 1 ? this.singlePassenger() : this.multiPassengerOnward() : ''}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            )
        } else {
            return (
                <div className='card'>
                    Loading...
                </div>
            )
        }
    }

    showInsurance = () => {
        return (
            <div style={{ padding: '25px 0', fontSize: '0.8rem' }}>
                <div style={{ display: 'inline-block', position: 'relative' }}>
                    <Check
                        value={this.state.insurance}
                        checked={this.state.insurance === 'on'}
                        handleChange={this.checkInsurance}
                        style={{ padding: '7px 5px' }}
                        name='insurance'
                        spanOuter='spnOuter'
                        lblOuter='lblOuter'
                    />
                </div>
                <div style={{ position: 'absolute', display: 'inline-block', paddingLeft: '0px', paddingTop: '3px' }}>Insure this trip @ {Rs} 20/berth <span style={{ color: window.color['searchBoxBgColor'] }} className='ins-check'>T&C {this.showInsuranceHover()}</span></div>
            </div>
        )
    }

    checkGst = () => {
        if (this.state.customerGSTN === "on") {
            if ((/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Z]){1}([a-zA-Z0-9]){1}?$/).test(this.state.companyGSTNo)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    ckPaymentOp = () => {
        let isActive = false;
        const ord = this.props.editPolicy.order.length !== 0 ? this.props.editPolicy.order : false;
        if (ord) {
            let temp = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach(el => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
            })
            let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
            let indianMobNo = (this.state.mobile + '').length === 10 && /^[0]?[6789]\d{9}$/.test(this.state.mobile);
            let internationalNo = (this.state.mobile + '').length < 20 && /^[0-9\-]+$/.test(this.state.mobile);
            let mobile = (countryCode && this.state.countryCode === '+91') ? indianMobNo : internationalNo;

            let passEmail = this.state.email;
            let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(passEmail.trim());

            if (temp && mobile && email && countryCode) {
                isActive = true
            }
        }
        if (isActive) {
            if (ord && ord.pgDetails.length === 0) {
                { this.checkPayment() }
            } else {
                this.setState({ paymentOption: true });
            }
        } else {
            alert('Please enter valid details')
        }
    }

    showPaymentOpBtn = () => {
        return (
            <div className="font16" style={{
                textAlign: 'center',
                color: '#FFF',
                background: window.color['buttonColor'],
                padding: '15px',
                borderRadius: '3px',
                position: 'fixed',
                bottom: '0',
                width: '100%',
                zIndex: '2',
                height: '50px',
                fontSize: '20px',
                fontWeight: '600',
            }} onClick={() => {
                this.ckPaymentOp(),
                    this.state.amountToPay > 0 ?
                        store.dispatch(updateHeaderText('text', 'payment-back-icon', 'text1', 'Select Payment Option', 'text2', '')) : ''
            }} >
                {this.state.amountToPay > 0 ? 'SELECT PAYMENT OPTION' : 'PROCEED'}
            </div>
        )
    }

    showDiv = () => {
        return (
            <div style={{
                backgroundColor: '#EEEEEE',
                padding: '15px',
                position: 'fixed',
                bottom: '0',
                width: '100%',
                zIndex: '2',
                height: '50px'
            }}></div>
        )
    }

    passContactInfoFn = () => {
        return (
            <div>
                <div className="font14" style={{
                    width: '100%',
                    height: 'calc(100% - 110px)',
                    position: 'absolute',
                    top: '60px',
                    left: '0px',
                    padding: '15px',
                    background: '#EEEEEE',
                    zIndex: '2',
                    overflowY: 'scroll'
                }}>
                    {this.enterContactDetails()}
                    {this.customerGSTN()}
                    {this.state.showInsurance ? this.showInsurance() : ''}
                    {this.showFareDetails()}
                </div>
                {this.state.mobile && this.state.email ? this.showPaymentOpBtn() : this.showDiv()}
            </div>
        )
    }

    enterContactDetails = () => {
        const tabCount = this.props.editPolicy.order.length !== 0 ? (this.props.editPolicy.order.onward.seats.length) * 4 : 0;
        return (
            <div className='contact-card disabled'
            >
                <div className='pass-info'>
                    <div className='mob-info'
                        style={{
                            padding: '15px 15px 15px 0',
                            display: 'inline-block',
                            width: '85px'
                        }}>
                        <LineInp
                            type='text'
                            value={this.state.countryCode}
                            handleChange={(e) => { this.setState({ countryCode: e.target.value }) }}
                            name='countrycode'
                            style={{
                                position: 'relative',
                                padding: '15px 0px',
                                display: 'inline-flex'
                            }}
                            max={8}
                            validation='countrycode'
                            isReadyOnly={true}
                            className='txtLineInp txtdisabled'
                        />
                    </div>
                    <LineInp
                        type='tel'
                        value={this.state.mobile}
                        placeholder='Mobile No'
                        name='mobileNo'
                        style={{
                            width: 'calc(100% - 85px)',
                            position: 'relative',
                            padding: '15px 0px',
                            display: 'inline-flex'
                        }}
                        tab={tabCount + 1}
                        validation='mobile'
                        isReadyOnly={true}
                        className='txtLineInp txtdisabled'
                    />
                </div>
                <div className='pass-info'>
                    <LineInp
                        type='text'
                        value={this.state.email}
                        placeholder='Email ID'
                        name='email'
                        style={{ width: '100%', display: 'inline-flex' }}
                        tab={tabCount + 2}
                        validation='email'
                        isReadyOnly={true}
                        className='txtLineInp txtdisabled'
                    />
                </div>
            </div>
        )
    }

    checkCustomerGSTN = (e, i) => {
        const customerGSTN = this.state.customerGSTN === 'on' ? 'off' : 'on';
        this.setState({ customerGSTN })
    }

    customerGSTN = () => {
        return (
            <div className='contact-gst' style={{
                padding: '25px 15px',
                background: '#FFF',
                boxShadow: '0 2px 4px rgba(0,0,0,.2)',
                borderRadius: '15px',
                marginTop: '25px',
            }}>
                <Check
                    value={this.state.customerGSTN}
                    checked={this.state.customerGSTN === 'on'}
                    handleChange={this.checkCustomerGSTN}
                    style={{ padding: '7px 5px' }}
                    name='customerGSTN'
                    spanOuter='spnOuter'
                    lblOuter='lblOuter'
                />
                I have GST number(optional)
                {
                    this.state.customerGSTN == 'on' ?
                        <div style={{ padding: '10px 0 0 0px' }}>
                            <div>
                                <LineInp
                                    type='text'
                                    value={this.state.companyGSTNo}
                                    handleChange={(e) => { this.setState({ companyGSTNo: e.target.value }) }}
                                    placeholder='Company Registered Number'
                                    name='GSTN'
                                    style={{ width: '100%', display: 'flex' }}
                                    className='txtLineInp'
                                />
                            </div>
                            <div>
                                <LineInp
                                    type='text'
                                    value={this.state.regCompanyName}
                                    handleChange={(e) => { this.setState({ regCompanyName: e.target.value }) }}
                                    placeholder='Registered Company Name'
                                    name='GSTNCompany'
                                    style={{ width: '100%', display: 'flex' }}
                                    className='txtLineInp'
                                />
                            </div>
                        </div> : ''
                }
            </div>
        )
    }

    handleClick = (gender, value) => {
        let male_count = 0;
        let female_count = 0;
        let old_female_count = 0;
        let old_male_count = 0;
        let oldData = this.state.oldBookingData;
        let index = 0;
        const ord = this.props.editPolicy.order.length !== 0 ? this.props.editPolicy.order : false;
        if (ord) {
            const onwards = ord.onward.seatDetails;
            oldData.PaxDetail.forEach(el => {
                if (el.Gender === 'M') { old_male_count++ }
                if (el.Gender === 'F') { old_female_count++ }
            })
            if (gender === 'Male' && male_count != old_male_count) {
                store.dispatch(updateUserGender('gender_reschedule', 'onward', value, gender));
            } else if (gender === 'Female' && female_count != old_female_count) {
                store.dispatch(updateUserGender('gender_reschedule', 'onward', value, gender));
            } else if (gender === 'Female' && female_count == old_female_count) {
                store.dispatch(updateUserGender('gender_reschedule', 'onward', value, ""));
            } else if (gender === 'Male' && male_count == old_male_count) {
                store.dispatch(updateUserGender('gender_reschedule', 'onward', value, ""));
            }
            Object.keys(onwards).forEach(el => {
                if (onwards[el].gender === 'Male') {
                    male_count++;
                } else if (onwards[el].gender === 'Female') {
                    female_count++;
                }
                index++;
            })
            if (female_count == old_female_count && male_count == old_male_count) {
                this.setState({ errormsg: '' })
            } else {
                this.setState({ errormsg: 'Please select ' + old_male_count + ' Male and ' + old_female_count + ' Female' })
            }
        }
    }

    checkInsurance = (e, i) => {
        const count = this.props.editPolicy.order.onward.seats.length;
        const insurance = this.state.insurance === 'on' ? 'off' : 'on';
        const insuranceVal = this.state.insurance === 'on' ? 0 : count * 20;
        this.setState({ insurance, insuranceVal })
    }

    showInsuranceHover = () => {
        return (
            <div className='ins-hover'>
                <strong>Super Reliability Service:</strong> Make alternate arrangements if bus services are cancelled including arrangements in upgraded buses.
                <br />
                <br />
                <strong>Free Personal accident Insurance</strong> Coverage of Rs.1,00,000/- (Rupees One Lakh) for death or dismemberment during journey under Personal Accident Policy from <strong>Tata AIG General Insurance Company Ltd</strong>.
            </div>
        )
    }

    showFareDetails = () => {
        const amountToPay = Math.round(this.state.onwardFare + this.state.onwardPickDrop + this.state.onwardScharge + this.state.insuranceVal + this.state.rescheduleCharge);
        let payableamount = (amountToPay - this.state.discountAmt - this.state.previousamount);
        return (
            <div className='side-info fare'>
                <div className='font14-dark' style={{ padding: '15px 0' }} >Review your booking</div>
                <div style={{
                    padding: '15px 0',
                    background: 'rgb(255, 255, 255)',
                    boxShadow: '0 2px 4px rgba(0,0,0,.2)',
                    lineHeight: '30px',
                    borderRadius: '15px'
                }}>
                    <div className='side-det' style={{ padding: '7px 15px' }}>
                        <div style={{ width: '80%', display: 'inline-block' }}>Onward Trip Fare ({this.props.editPolicy.order.length !== 0 ? this.props.editPolicy.order.onward.seats.length : 0} seats)</div>
                        <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.onwardFare - this.state.onwardGst}</div>
                    </div>
                    {this.state.onwardGst ?
                        <div className='side-det' style={{ padding: '7px 15px' }}>
                            <div style={{ width: '80%', display: 'inline-block' }}>Onward Trip GST</div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.onwardGst}</div>
                        </div> : ''
                    }

                    {this.state.onwardPickDrop ?
                        <div className='side-det' style={{ padding: '7px 15px' }}>
                            <div style={{ width: '80%', display: 'inline-block' }}>Pickup / Drop Charges</div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.onwardPickDrop}</div>
                        </div> : ''
                    }

                    {this.state.onwardScharge ?
                        <div className='side-det' style={{ padding: '7px 15px' }}>
                            <div style={{ width: '80%', display: 'inline-block' }}>Service Charge</div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.onwardScharge}</div>
                        </div> : ''
                    }

                    {this.state.insuranceVal !== 0 ?
                        <div className='side-det' style={{ padding: '7px 15px' }}>
                            <div style={{ width: '80%', display: 'inline-block' }}>
                                Travel insurance&nbsp;
                            </div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.insuranceVal}</div>
                        </div> : ''
                    }
                    {this.state.rescheduleCharge !== 0 ?
                        <div className='side-det' style={{ padding: '7px 15px' }}>
                            <div style={{ width: '80%', display: 'inline-block' }}>
                                Reschedule Charges
                            </div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right' }}>&#8377;{this.state.rescheduleCharge}</div>
                        </div> : ''
                    }
                    {this.state.discountAmt !== 0 ?
                        <div className='side-det' style={{ padding: '7px 15px', background: '#DFF0D8' }}>
                            <div style={{ width: '80%', display: 'inline-block', color: '#3c763D', fontWeight: '400' }}>Discount</div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right', color: '#3c763D', fontWeight: '400' }}> &#8377;{this.state.discountAmt}</div>
                        </div> : ''
                    }
                    {this.state.previousamount !== 0 ?
                        <div className='side-det' style={{ padding: '7px 15px', background: '#DFF0D8' }}>
                            <div style={{ width: '80%', display: 'inline-block', color: '#3c763D', fontWeight: '400' }}>Previous Booking Amount</div>
                            <div style={{ width: '20%', display: 'inline-block', textAlign: 'right', color: '#3c763D', fontWeight: '400' }}>- &#8377;{this.state.previousamount}</div>
                        </div> : ''
                    }
                    <div className='side-det' style={{ padding: '7px 15px' }}>
                        <div style={{ width: '60%', display: 'inline-block' }}>Total Payable Amount</div>
                        <div style={{ width: '40%', display: 'inline-block', textAlign: 'right' }}>
                            {(parseInt(this.state.discountAmt, 10)) !== 0 ?
                                <span style={{ paddingRight: '10px' }}>
                                    <strike>&#8377;{amountToPay}</strike>
                                </span> : ''}
                            <span>
                                &#8377;{payableamount > 0 ? payableamount : 0}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    selPaymentOption = () => {
        if (this.props.editPolicy.order && this.props.editPolicy.order.pgDetails && this.props.editPolicy.order.pgDetails.length > 0) {
            const loop = this.props.editPolicy.order.pgDetails;
            return (
                <div className="font14" style={{
                    width: '100%',
                    height: 'calc(100% - 110px)',
                    padding: '0px',
                    background: '#EEEEEE',
                    zIndex: '3',
                    position: 'absolute',
                    top: '60px',
                    left: '0px',
                    overflowY: 'scroll'
                }}>
                    <div className='card' style={{ background: '#FFF', padding: '0px', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)', borderRadius: '3px' }}>
                        <div className='pay-opts'>
                            <div>
                                {loop.map((el, index) => {
                                    return (
                                        <div className="paymentOpt" key={index} style={{ width: '100%', padding: '20px 15px', fontWeight: '600', fontSize: '16px' }}>
                                            <Radio
                                                value={el.pg}
                                                checked={this.state.payopt === el.pg}
                                                handleChange={(event) => this.setState({ payopt: event.target.value })}
                                                showValue={el.DisplayText}
                                                name='PGType'
                                                lblClass='payment-opt-label'
                                                spanOuterClass='span-outer'
                                                spanInnerClass='span-inner'
                                            />
                                            <div className="pg--arrow"></div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {this.showPayBtn()}
                    </div>
                    {this.termAndCondition()}
                </div>
            )
        }
    }

    termAndCondition = () => {
        return (
            <div className="terms--wrap" style={{ paddingBottom: '30px' }}>
                <div
                    style={{
                        display: 'flex',
                        margin: '15px 0',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <img src={getImgPath("/img/positivessl_trust_seal.png")}
                        alt="sectigo logo" />
                </div>
                <div style={{ textAlign: 'center', color: '#202020', fontWeight: '500' }}>By paying here you agree to our T&amp;C </div>
            </div>
        )
    }

    showPayBtn = () => {
        return <div className="font16"
            style={{
                padding: '15px',
                textAlign: 'center',
                width: '100%',
                borderRadius: '3px',
                color: '#fff',
                background: window.color['buttonColor'],
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
                left: '0',
                bottom: '0',
                position: 'fixed',
                height: '50px'
            }}
            onClick={this.checkPayment}
        >MAKE PAYMENT</div>
    }

    checkPayment = () => {
        const isGenderCheck = window.location.href.split('p=').length > 1 ? window.location.href.split('p=')[1].split('&')[0] : false;
        if (isGenderCheck) {
            let counter = 1;
            const routeCode = this.props.editPolicy.order.onward.routeCode;
            const loop = this.props.editPolicy.order.onward.seatDetails;
            let url = '/api/resource/APIGenderValidate?RouteCode=' + routeCode;
            Object.keys(loop).forEach(el => {
                url += ('&SeatLabel_' + counter + '=' + el + '&Gender_' + counter + '=' + (loop[el].gender === 'Male' ? 'M' : 'F'));
                counter++;
            })
            fetchGet(url).then(function (data) {
                const response = JSON.parse(data).APIBooking_GenderValidationResult;
                if (response.Status) {
                    document.getElementById('checkoutForm').submit();
                } else {
                    alert(response.ErrorMessage);
                    window.history.back();
                }
            }).catch(function (error) {
                alert(error);
            });
        } else {
            document.getElementById('checkoutForm').submit();
        }
    }

    customerInfoHiddenInput = () => {
        const ord = this.props.editPolicy.order;
        const loop = ord.length !== 0 ? ord.onward.seats : false;
        if (loop) {
            const seats = ord.onward.seatDetails;
            return (
                <div>
                    {
                        loop.map((el, index) => {
                            return (
                                <div key={index}>
                                    <input type='hidden' name={'paxName[' + index + ']'} value={seats[el].name || ''} />
                                    <input type='hidden' name={'paxGender[' + index + ']'} value={seats[el].gender || ''} />
                                    <input type='hidden' name={'paxAge[' + index + ']'} value={seats[el].age || ''} />
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
    }

    getMobile = () => {
        let mob = this.state.mobile.replace(/\-/g, '');
        const mobNo = this.state.countryCode == '+91' ? mob : this.state.countryCode + mob;
        return mobNo;
    }

    render() {
        let customername = this.state.oldBookingData.PassengerName ? this.state.oldBookingData.PassengerName : '';
        let amountToPay = this.state.amountToPay + parseInt(this.state.insuranceVal, 10);
        if (this.state.oldBookingData) {
            return (
                <section className='checkout-wrapper'>
                    <Modify />
                    <form id='checkoutForm' method='POST' action={'/co/confirmV2'}>
                        <input type='hidden' name='query' value={'{"hop":"direct","mode":"' + mode + '","otaId":"0","FromCityId":"' + fromCityId + '","ToCityId":"' + toCityId + '","fromCityName":"' + fromCity + '","toCityName":"' + toCity + '","JourneyDate":"' + journeyDate + '","NoOfSeats":false,"SearchId":0,"returnDate":false}'} />
                        <input type='hidden' name='o' id='o' value={this.props.match.params.token} />
                        <input type='hidden' name='owo' value='0' />
                        <input type='hidden' name='method' id='method' value='1' />
                        <input type='hidden' name='provider' id='provider' value='1' />
                        <input type='hidden' name='hd_charges' id='hd_charges' value='0' />
                        <input type='hidden' name='mobile' id='mobile' value={this.getMobile()} />
                        <input type='hidden' name='amountToPay' id='amountToPay' value={amountToPay > 0 ? amountToPay : 0} />
                        <input type='hidden' name='customerName' id='customerName' value={customername} />
                        <input type='hidden' name='oldpnrNo' id='oldpnrNo' value={window.location.href.split('/')[6].split('?')[0]} />
                        {this.enterPassDetailsOnwards()}
                        {this.state.passContactInfo === true ? this.passContactInfoFn() : ''}
                        {this.state.paymentOption === true ? this.state.amountToPay > 0 ? this.selPaymentOption() : this.checkPayment() : ''}
                        {this.customerInfoHiddenInput()}
                    </form>
                </section>
            );
        } else {
            return (
                <div style={{ position: "fixed", textAlign: "center", paddingTop: "50%", width: "100%", height: "100%", backgroundColor: "rgba(255,255,255,0.6)" }}>Loading....</div>
            );
        }
    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(Checkout);


// WEBPACK FOOTER //
// ./src/components/checkout/checkout.js